import {Component, OnInit} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {AuthService} from '../../authentication/auth-service';
import {NgClass} from '@angular/common';
import {CondominiumListService} from '../../claims/control/condominium-list-service';
import {LocalizationPipePipe} from '../../localization/control/localisation-pipe-pipe';
import {LanguageSelector} from '../../localization/boundary/language-selector/language-selector';
import {ObjectType} from '../../claims/entity/claim-item';
import {YearSelector} from '../../claims/boundary/year-selector/year-selector';

@Component({
  selector: 'app-menu',
  imports: [
    RouterLink,
    RouterLinkActive,
    NgClass,
    LocalizationPipePipe,
    LanguageSelector,
    YearSelector
  ],
  templateUrl: './menu.html',
  styleUrl: './menu.scss'
})
export class Menu implements OnInit {
  protected isAuthenticated: boolean = false
  protected isAdjustor: boolean = false
  protected isMenuOpen: boolean = false;
  protected isCreateClaimMenuOpen: boolean = false;

  constructor(
    private readonly authService: AuthService,
    private readonly condominiumListService: CondominiumListService) {
  }

  ngOnInit(): void {
    this.authService.user$.subscribe(u => {
      if (u) {
        this.isAuthenticated = this.authService.isAuthenticated;
      } else {
        this.isAuthenticated = this.authService.isAuthenticated;
      }
      this.isAdjustor = this.isAuthenticated // && this.authService.userHasRole('adjustor')
    })
  }

  protected initiateLogin() {
    this.authService.login().then(r => console.log(r))
  }

  protected triggerLogout() {
    this.toggleMenu()
    this.condominiumListService.clearCache();
    this.authService.logout().then(r => console.log(r))
  }

  protected getUsername(): string | undefined {
    let profile = this.authService.getCurrentUser()?.profile;
    if (!profile) return undefined;
    return profile?.given_name + " " + profile?.family_name
  }

  protected onClickCreateClaimMenuOpen() {
    this.isCreateClaimMenuOpen = !this.isCreateClaimMenuOpen;
    this.toggleMenu();
  }

  protected toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  protected readonly ObjectType = ObjectType;
}
